var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProcessingCheckMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1925 20.1925L9.6925 16.6925C9.3025 16.3025 8.6825 16.3025 8.2925 16.6925C7.9025 17.0825 7.9025 17.7025 8.2925 18.0925L12.4825 22.2825C12.8725 22.6725 13.5025 22.6725 13.8925 22.2825L24.4925 11.6925C24.8825 11.3025 24.8825 10.6825 24.4925 10.2925C24.1025 9.9025 23.4825 9.9025 23.0925 10.2925L13.1925 20.1925Z",
    fill: "#080206"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProcessingCheckMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/processing-check-mark.b1f1a8645657f7411a1bd154740845fa.svg";